import { PText, PTextFieldWrapper } from '@porsche-design-system/components-react'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import { TEXTS } from '../../config/texts'

import styles from './appidfield.module.css'

type Props = {
  defaultValue?: string
}

const AppIDField = ({ defaultValue }: Props) => {
  const newDefaultValue = defaultValue?.replace(/APP-/gi, '')
  const { register } = useFormContext()

  return (
    <PTextFieldWrapper label={TEXTS.APP_ID_LABEL} className={styles.textfield} unit={TEXTS.APP_ID_INPUT_MASK}>
      <input
        type='number'
        name='appId'
        placeholder={TEXTS.APP_ID_PLACEHOLDER}
        ref={register}
        className={styles.appIdField}
        defaultValue={newDefaultValue}
      />
    </PTextFieldWrapper>
  )
}

export default AppIDField
